import { useLazyLoadQuery } from "react-relay";
import { graphql } from "relay-runtime";
import { ProductTrack } from "../ProductTrack";
import { RecommendedProductsQuery } from "./__generated__/RecommendedProductsQuery.graphql";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";

const query = graphql`
	query RecommendedProductsQuery($hubId: UUID!) {
		hub(id: $hubId) @required(action: THROW) {
			products(pagination: { page: 0, pageSize: 1000000 }) {
				...ProductTrackFragment
				nodes {
					stock
				}
			}
		}
	}
`;

type RecommendedProductsProps = {
	hubId: string;
	showAddButton?: boolean;
	onProductClick?: (hubProductId: string) => void;
	hideOutOfStock?: boolean;
	title?: string;
	showSectionTitle?: boolean;
};

export const RecommendedProducts = (props: RecommendedProductsProps) => {
	const { hubId, showAddButton = true, hideOutOfStock = false, showSectionTitle = true } = props;
	const { hub } = useLazyLoadQuery<RecommendedProductsQuery>(query, { hubId });
	const i18n = useI18nContext().LL["new-ui"];
	const title = props.title ?? i18n.RECOMMENDED_TITLE();

	// Check if we have any in-stock products when hideOutOfStock is true
	if (hideOutOfStock) {
		const hasInStockProducts = hub.products.nodes?.some((p) => p.stock > 0);
		if (!hasInStockProducts) {
			return null;
		}
	}

	return (
		<>
			{showSectionTitle && (
				<h2 className="text-xl font-breit px-6 pt-4">
					<T>{i18n.RECOMMENDED()}</T>
				</h2>
			)}
			<ProductTrack
				tab=""
				products={hub.products}
				showAddButton={showAddButton}
				hideOutOfStock={hideOutOfStock}
				onProductClick={props.onProductClick}
				title={title}
			/>
		</>
	);
};
